import { render, staticRenderFns } from "./Benutzereinstellungen.vue?vue&type=template&id=525eeeaf&scoped=true&"
import script from "./Benutzereinstellungen.vue?vue&type=script&lang=js&"
export * from "./Benutzereinstellungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525eeeaf",
  null
  
)

export default component.exports